module.exports = __webpack_public_path__ + "static/media/info-production.b46a12d1.jpg";